/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _defineProperty from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tab from "vux/src/components/tab/tab.vue"; // this line is trasformed by vux-loader
import TabItem from "vux/src/components/tab/tab-item.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import PopupHeader from "vux/src/components/popup-header/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Panel from './Panel';
export default {
  name: 'SelectPicker',
  directives: {
    TransferDom: TransferDom
  },
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 3,
      validator: function validator(n) {
        return n > 0 && Number.isInteger(n);
      }
    },
    title: {
      type: String,
      default: i18n.tc("237")
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenKey: {
      type: String,
      default: 'dropList'
    }
  },
  components: {
    Panel: Panel,
    Tab: Tab,
    TabItem: TabItem,
    Popup: Popup,
    PopupHeader: PopupHeader
  },
  computed: {
    isShow: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    },
    flatList: function flatList() {
      function flatTree() {
        var tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        function format(v) {
          return v;
        }
        try {
          return tree.reduce(function (p, c) {
            p = p.concat(format(c)).concat(flatTree(c.dropList));
            return p;
          }, []);
        } catch (error) {
          console.log('flatTree -> error', error);
          return [];
        }
      }
      var flatList = flatTree(this.list);
      return flatList;
    },
    displayJsonFilter: function displayJsonFilter() {
      var _this = this;
      return this.displayJson.filter(function (_, i) {
        return i < _this.level;
      });
    }
  },
  watch: {
    list: {
      handler: function handler(v) {
        this.getDisplayJson(v);
      },
      immediate: true,
      deep: true
    },
    data: {
      handler: function handler() {
        var _this2 = this;
        var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.selectedValue = arr.map(function (v) {
          var tmp = _this2.flatList.find(function (flat) {
            return flat.id === v;
          }) || {};
          return _defineProperty({
            id: v,
            value: tmp.value
          }, _this2.childrenKey, tmp[_this2.childrenKey]);
        });
        var name = this.selectedValue.length ? this.selectedValue.map(function (v) {
          return v.value;
        }).join(',') : '';
        this.$emit('on-change-name', name);
        this.selectedValue.forEach(function (area, i) {
          _this2.getDisplayJson(area[_this2.childrenKey], i + 1);
        });
      },
      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      selectedValue: [],
      displayJson: []
    };
  },
  methods: {
    leftClick: function leftClick() {
      this.isShow = false;
    },
    rigthClick: function rigthClick() {
      this.isShow = false;
      this.$emit('on-change', this.selectedValue.map(function (v) {
        return v.id;
      }), this.selectedValue);
      var name = this.selectedValue.length ? this.selectedValue.map(function (v) {
        return v.value;
      }).join(',') : '';
      this.$emit('on-change-name', name);
    },
    setPositon: function setPositon() {
      var _this3 = this;
      this.selectedValue.forEach(function (v, i) {
        if (v.id) {
          var index = _this3.realList[i].data.findIndex(function (value) {
            return value.id === v.id;
          });
          _this3.$refs['area-list'][i].scroll(0, 32 * index);
        }
      });
    },
    change: function change(area) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (this.selectedValue.length - 1 > type) {
        this.selectedValue.splice(type, this.selectedValue.length - type, area);
      } else {
        this.$set(this.selectedValue, type, area);
      }
      this.getDisplayJson(area[this.childrenKey], type + 1);
    },
    getDisplayJson: function getDisplayJson() {
      var child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (this.displayJson.length - 1 > type) {
        this.displayJson.splice(type, this.displayJson.length - type, child);
      } else {
        this.$set(this.displayJson, type, child);
      }
    }
  }
};